import { Grid, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { buildDrillDownHref, pick } from "../managementDashboardUtils";
import ExecutiveKpiCard from "../ExecutiveKpiCard";

const ALERT_HEALTH_SPECS = [
  {
    key: "stuck7",
    title: "معطل بیش از ۷ روز",
    match: (a) => (a.thresholdDays ?? a.ThresholdDays ?? 0) >= 7 && (a.count ?? a.Count) > 0,
  },
  {
    key: "stuck14",
    title: "معطل بیش از ۱۴ روز",
    match: (a) => (a.thresholdDays ?? a.ThresholdDays ?? 0) >= 14 || (a.oldestItemAgeDays ?? a.OldestItemAgeDays ?? 0) >= 14,
  },
  {
    key: "noContractor",
    title: "بدون پیمانکار",
    codes: ["CreditValidatedNoSiteVisit", "ReadyNoSiteVisit"],
  },
  {
    key: "loanPending",
    title: "در انتظار تأیید وام",
    codes: ["InitiallyApprovedNotSentToLender", "LendingPlatformNoUpdate", "LendingStepStalled"],
  },
  {
    key: "contractWaiting",
    title: "قرارداد در انتظار اقدام",
    codes: ["CustomerContractIncomplete", "CustomerPriceOfferAwaiting"],
  },
  {
    key: "sla",
    title: "نقض SLA",
    codes: ["InstallationStalled", "InstallationCompleteNoGrid", "NeedsCorrectionWaitingCustomer"],
  },
];

const sumAlerts = (alerts, spec) => {
  const list = alerts.filter((a) => (a.count ?? a.Count) > 0);
  if (spec.match) {
    return list.filter(spec.match);
  }
  if (spec.codes) {
    return list.filter((a) => spec.codes.includes(pick(a, "code", "Code")));
  }
  return [];
};

const BusinessHealthSummary = ({ alertsData, loading, error, onRetry }) => {
  const alerts = alertsData?.alerts || alertsData?.Alerts || [];

  return (
    <>
      <Typography fontWeight={700} fontSize={16} sx={{ mb: 1.5 }}>
        سلامت کسب‌وکار
      </Typography>
      <Grid container spacing={1.5}>
        {ALERT_HEALTH_SPECS.map((spec) => {
          const matched = sumAlerts(alerts, spec);
          const total = matched.reduce((sum, a) => sum + (a.count ?? a.Count ?? 0), 0);
          const primary = matched[0];
          const drillHref = primary
            ? buildDrillDownHref(pick(primary, "drillDown", "DrillDown"))
            : null;

          return (
            <Grid item xs={12} sm={6} md={4} key={spec.key}>
              <ExecutiveKpiCard
                kpi={{
                  title: spec.title,
                  value: total,
                  unit: "مورد",
                  isAvailable: true,
                  metricType: 2,
                  comparisonState: 3,
                  drillDown: primary?.drillDown || primary?.DrillDown,
                }}
                loading={loading}
                error={error}
                onRetry={onRetry}
              />
              {drillHref ? (
                <Typography
                  component={RouterLink}
                  to={drillHref}
                  variant="caption"
                  color="primary"
                  sx={{ textDecoration: "none", px: 0.5, display: "inline-block", mt: 0.5 }}
                >
                  مشاهده لیست فیلترشده
                </Typography>
              ) : null}
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default BusinessHealthSummary;
